import React from 'react';
import _ from 'underscore';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { BiAddToQueue } from 'react-icons/bi';
import cn from 'classnames';

import { Page } from 'ui/components';
import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';
import useTable from 'ui/components/table';

import tableConfig from './component/table.config';
import Tutorial from './component/tutorial';

import { FormInput } from './component/create';
import BulkImport from './component/modal/bulk';
import SingleInput from './component/modal/single';
import { FormBulkUpdate } from './component/modal/form';
import TableImport from './component/modal/tabel.import';
import { Table, Driver } from 'services/action';

const initialState = {
  privilege: null,
  isShow: false,
  imports: [],
  update: null,
  types: null, // single or bulk_import
};

const DriverScreen = () => {
  const Dispatch = useDispatch();
  const DriverTable = useTable('driver', tableConfig);

  const Session = useSelector((state) => state.Auth?.session);
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['driver']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ privilege, isShow, imports, update, types }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isShow: false,
      imports: [],
      update: null,
      types: null,
    }));
  };

  const $resetTable = async () => {
    $handleClose();
    Dispatch(Table.$reload('driver', StateTable));
  };

  const $handleUpdate = async (d, id) => {
    const u = { id: id, data: imports[id] };
    setState((prevState) => ({
      ...prevState,
      update: u,
    }));
  };

  const $handleDelete = async (id) => {
    let newList = [...imports];
    newList.splice(id, 1);
    setState((prevState) => ({
      ...prevState,
      imports: newList,
      update: null,
    }));
  };

  const $onUpdate = async (d) => {
    let newList = [...imports];
    newList[update?.id] = d;

    setState((prevState) => ({
      ...prevState,
      imports: newList,
      update: null,
    }));
  };

  const $handleSubmit = async (c) => {
    const payload = {
      datas: imports,
    };

    const req = await Dispatch(Driver.$createBulk(payload));

    if (req?.message === 'success') {
      $resetTable();
    }
  };

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.driver',
    });
    setState((prevState) => ({
      ...prevState,
      privilege: x,
    }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  return (
    <Page className="col-12 col-md-8 bordered">
      <Page.Header pretitle="Daftar" title={'Driver'} isLoading={StateLoading}>
        {(privilege?.action === 'manage' || !Session?.privileges) && (
          <button
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
            className="btn btn-primary px-2"
          >
            <BiAddToQueue color="white" size="14" />
            <span className="d-none d-md-block ms-1">Tambah Driver</span>
          </button>
        )}
      </Page.Header>

      <Page.Navigation>
        <Tutorial />
        <DriverTable.Tools isLoading={StateLoading} downloadable />
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div className="col-md-12 m-0 p-0">
          {StateLoading ? (
            <SkeletonTable headerCount={6} bodyCount={10} />
          ) : (
            <DriverTable.Render />
          )}
        </div>
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <DriverTable.Pagination />}
      </Page.Footer>

      <Modal
        show={isShow}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Driver</Modal.Title>
        </Modal.Header>
        {(types === null ||
          (types === 'bulk_import' && imports?.length) === 0) && (
          <div className="row border bg-white m-0">
            <div className="col-md-5 border-bottom-sm d-flex justify-content-center align-items-center">
              <BulkImport
                onImported={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    imports: [...prevState?.imports, e],
                    types: 'bulk_import',
                    update: null,
                  }))
                }
              />
            </div>
            <div className="col-md-2 d-flex justify-content-center align-items-center  position-relative">
              <div
                className="position-absolute top-50 start-50 translate-middle d-none d-md-flex"
                style={{
                  height: 150,
                  width: 0.5,
                  backgroundColor: '#848484',
                }}
              />
              <div
                className="rounded-circle bg-white d-flex justify-content-center align-items-center fs-8 text-uppercase fw-bold text-grey"
                style={{
                  width: 70,
                  height: 70,
                  zIndex: 9,
                  border: '1px solid #848484',
                }}
              >
                atau
              </div>
            </div>
            <div className="col-md-5  d-flex justify-content-center align-items-center">
              <SingleInput
                onPress={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    types: 'single',
                    imports: [],
                    update: null,
                  }))
                }
              />
            </div>
          </div>
        )}

        {types === 'bulk_import' && imports?.length > 0 && (
          <>
            <Modal.Body>
              {update ? (
                <FormBulkUpdate
                  data={update?.data}
                  onSubmit={$onUpdate}
                  onClose={() => {
                    setState((prevState) => ({ ...prevState, update: null }));
                  }}
                />
              ) : null}

              <div className="mt-3">
                <TableImport
                  data={imports}
                  onChange={() => {
                    setState((prevState) => ({ ...prevState, imports: imports }));
                  }}
                  onDelete={$handleDelete}
                  onUpdate={$handleUpdate}
                />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <div className="row w-100">
                <div className="col">
                  <Button
                    type="button"
                    className="btn btn-light w-100"
                    onClick={() => $handleClose()}
                  >
                    Batal
                  </Button>
                </div>
                <div className="col">
                  <Button
                    type="button"
                    className={cn(
                      StateForm?.loading ? 'btn-loading' : '',
                      'btn btn-primary w-100'
                    )}
                    disabled={StateForm?.loading}
                    onClick={$handleSubmit}
                  >
                    Simpan
                  </Button>
                </div>
              </div>
            </Modal.Footer>
          </>
        )}
        {types === 'single' && (
          <FormInput onClose={$handleClose}/>
        )}
      </Modal>
    </Page>
  );
};

export default DriverScreen;
